"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolNotFoundError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`School not found for id: ${schoolId}`);
        this.schoolId = schoolId;
    }
}
exports.default = SchoolNotFoundError;
//# sourceMappingURL=SchoolNotFoundError.js.map